export const TEMPLATE_SECTION_KEYS = [
  'newOrderText',
  'completedOrderText',
  'shoePromoText',
  'clothesPromoText',
  'imageCodeText',
  'newGroupOrderText',
  'completedGroupOrderText',
] as const;

export type TemplateSectionKey = (typeof TEMPLATE_SECTION_KEYS)[number];

export interface NotificationTemplateResponse {
  lang: string;
  newOrderText: string;
  completedOrderText: string;
  shoePromoText: string;
  clothesPromoText: string;
  imageCodeText: string;
  newGroupOrderText: string;
  completedGroupOrderText: string;
}

export interface UpdateNotificationTemplateItem {
  lang: string;
  newOrderText?: string;
  completedOrderText?: string;
  shoePromoText?: string;
  clothesPromoText?: string;
  imageCodeText?: string;
  newGroupOrderText?: string;
  completedGroupOrderText?: string;
}
